export const OOPS = {
  pt: "Ops...",
  es: "Epa...",
  en: "Oops...",
};

export const ALL_RIGHT = {
  pt: "Tudo certo!",
  es: "¡Muy bien!",
  en: "All set!",
};

export const ADMIN = {
  pt: "Admin",
  es: "Admin",
  en: "Admin",
};

export const MANAGEMENT = {
  pt: "Administração",
  es: "Administración",
  en: "Administration",
};

export const CAR_CATALOG = {
  pt: "Catálogo de carros",
  es: "Catálogo de autos",
  en: "Car catalog",
};

export const BRAND_PLACEHOLDER = {
  pt: "Cadastre uma nova marca",
  es: "Registra una nueva marca",
  en: "Register a new brand",
};

export const ADD_BRAND = {
  pt: "Adicionar marca",
  es: "Agregar marca",
  en: "Add brand",
};

export const REQUIRED_FIELD = {
  pt: "Campo obrigatório",
  es: "Campo obligatorio",
  en: "Required field",
};

export const BRAND_CREATED_SUCCESS = {
  pt: "Marca criada com sucesso!",
  es: "¡Marca creada con éxito!",
  en: "Brand created successfully!",
};

export const ERROR_CREATE_BRAND = {
  pt: "Não foi possível criar a marca.",
  es: "No se pudo crear la marca.",
  en: "Could not create the brand.",
};

export const ERROR_FETCH_BRANDS = {
  pt: "Não foi possível carregar as marcas.",
  es: "No se pudieron cargar las marcas.",
  en: "Could not load brands.",
};

export const NEW_MODEL = {
  pt: "Novo modelo",
  es: "Nuevo modelo",
  en: "New model",
};

export const MODEL_CREATED_SUCCESS = {
  pt: "Modelo criado com sucesso!",
  es: "¡Modelo creado con éxito!",
  en: "Model created successfully!",
};

export const ERROR_CREATE_MODEL = {
  pt: "Não foi possível criar o modelo.",
  es: "No se pudo crear el modelo.",
  en: "Could not create the model.",
};

export const ERROR_FETCH_PLUGS = {
  pt: "Não foi possível carregar os plugs.",
  es: "No se pudieron cargar los conectores.",
  en: "Could not load plugs.",
};

export const SAVE = {
  pt: "Salvar",
  es: "Guardar",
  en: "Save",
};

export const CANCEL = {
  pt: "Cancelar",
  es: "Cancelar",
  en: "Cancel",
};

export const NAME = {
  pt: "Nome",
  es: "Nombre",
  en: "Name",
};

export const VERSION = {
  pt: "Versão",
  es: "Versión",
  en: "Version",
};

export const TYPE = {
  pt: "Tipo",
  es: "Tipo",
  en: "Type",
};

export const TYPE_ELECTRIC = {
  pt: "Elétrico",
  es: "Eléctrico",
  en: "Electric",
};

export const TYPE_HYBRID = {
  pt: "Híbrido",
  es: "Híbrido",
  en: "Hybrid",
};

export const CAPACITY = {
  pt: "Capacidade (kWh)",
  es: "Capacidad (kWh)",
  en: "Capacity (kWh)",
};

export const USABLE_CAPACITY = {
  pt: "Capacidade utilizável (kWh)",
  es: "Capacidad utilizable (kWh)",
  en: "Usable capacity (kWh)",
};

export const AC_POWER = {
  pt: "Potência AC (kW)",
  es: "Potencia AC (kW)",
  en: "AC power (kW)",
};

export const DC_POWER = {
  pt: "Potência DC (kW)",
  es: "Potencia DC (kW)",
  en: "DC power (kW)",
};

export const AUTONOMY = {
  pt: "Autonomia (km)",
  es: "Autonomía (km)",
  en: "Autonomy (km)",
};

export const PLUGS = {
  pt: "Plugs",
  es: "Conectores",
  en: "Plugs",
};

export const PLUGS_PLACEHOLDER = {
  pt: "Selecione os plugs compatíveis",
  es: "Selecciona los conectores compatibles",
  en: "Select compatible plugs",
};

export const NO_BRANDS = {
  pt: "Nenhuma marca cadastrada.",
  es: "No hay marcas registradas.",
  en: "No brands registered.",
};

export const NO_MODELS = {
  pt: "Nenhum modelo cadastrado.",
  es: "No hay modelos registrados.",
  en: "No models registered.",
};
